import { useEffect } from 'react'

const ScrollReveal = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed')
        }
      })
    }, observerOptions)

    // Observe all elements with scroll-reveal class
    const scrollRevealElements = document.querySelectorAll('.scroll-reveal')
    scrollRevealElements.forEach((element) => {
      observer.observe(element)
    })

    return () => {
      scrollRevealElements.forEach((element) => {
        observer.unobserve(element)
      })
    }
  }, [])

  return null
}

export default ScrollReveal